// extracted by mini-css-extract-plugin
export default {"question":"FAQ_question__YGV0M","questionItem":"FAQ_questionItem__3yBYI","questionTitle":"FAQ_questionTitle__m4AbM"};